module.exports = __webpack_public_path__ + "img/Group 3758.42d1f8bd.svg";